


























import { defineComponent, computed } from '@vue/composition-api';
import { DeeplinkType, DEEPLINK_TYPES } from '@tt4b/ttam-enums';

const name = 'ttam-creative-deffered-deeplink-dpa-select';

export default defineComponent({
  name,
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onlySupportCustomLink: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const deepLinkTypeList = computed(() =>
      DEEPLINK_TYPES.map(item => ({
        ...item,
        hide: item.value === DeeplinkType.ProductLink && props.onlySupportCustomLink,
      })),
    );
    //
    const _deepLinkType = computed({
      get: () => props.value,
      set: v => {
        emit('change', v);
        emit('input', v);
      },
    });
    return {
      name,
      _deepLinkType,
      deepLinkTypeList,
    };
  },
});
